import { Box } from "@mui/material";
import Navbar from "scenes/navbar";
import Sidebar from "scenes/sidebar/Sidebar";
// import Post from "scenes/post/Post";
import { Outlet } from "react-router-dom";

const HomePage = () => {
  return (
    <Box display="flex">
      <Sidebar />
      <Box flexGrow={1} sx={{ paddingTop: "74px" }}>
        <Navbar />
        <Box sx={{ padding: "20px" }}>
          <Outlet />  {/* ✅ This dynamically loads child routes */}
          {/* <Post/> */}
        </Box>
      </Box>
    </Box>
  );
};

export default HomePage;
